import '@/App.css';
import { HelmetProvider } from 'react-helmet-async';
import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Outlet, useLocation } from 'react-router-dom';
import { Navigation } from './components/Navigation';
import { Footer } from './components/Footer';
import { AccessibilityButton } from './components/AccessibilityButton';
import CookieBanner from './components/CookieBanner';
import { Analytics } from '@vercel/analytics/react';
import { SpeedInsights } from '@vercel/speed-insights/react';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import OilsPage from './pages/OilsPage';
import ContactPage from './pages/ContactPage';
import ExaminationPage from './pages/services/ExaminationPage';
import DelayedSpeechPage from './pages/services/DelayedSpeechPage';
import ArticulationPage from './pages/services/ArticulationPage';
import DyslexiaPreventionPage from './pages/services/DyslexiaPreventionPage';
import SpeechPerceptionPage from './pages/services/SpeechPerceptionPage';
import TongueThrustPage from './pages/services/TongueThrustPage';
import LanguageDisorderPage from './pages/services/LanguageDisorderPage';
import PrivacyPage from './pages/PrivacyPage';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
}

function Layout() {
  return (
    <div className="min-h-screen bg-white">
      <ScrollToTop />
      <a
        href="#main-content"
        className="skip-to-content"
        data-testid="skip-to-content"
      >
        Ugrás a tartalomhoz
      </a>
      <header role="banner">
        <Navigation />
      </header>
      <AccessibilityButton />
      <main id="main-content" role="main" tabIndex={-1}>
        <Outlet />
      </main>
      <Footer />
      <CookieBanner />
    </div>
  );
}

function App() {
  return (
    <>
    <HelmetProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<HomePage />} />
            <Route path="rolam" element={<AboutPage />} />
            <Route path="szolgaltatasok" element={<ServicesPage />} />
            <Route path="szolgaltatasok/vizsgalat" element={<ExaminationPage />} />
            <Route path="szolgaltatasok/megkesett-beszed" element={<DelayedSpeechPage />} />
            <Route path="szolgaltatasok/artikulacios-zavar" element={<ArticulationPage />} />
            <Route path="szolgaltatasok/diszlexia-prevencio" element={<DyslexiaPreventionPage />} />
            <Route path="szolgaltatasok/beszedeszleles" element={<SpeechPerceptionPage />} />
            <Route path="szolgaltatasok/nyelvlokeses-nyeles" element={<TongueThrustPage />} />
            <Route path="szolgaltatasok/nyelvi-fejlodes" element={<LanguageDisorderPage />} />
            <Route path="illoolajok" element={<OilsPage />} />
            <Route path="adatkezeles" element={<PrivacyPage />} />
            <Route path="kapcsolat" element={<ContactPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Analytics />
      <SpeedInsights />
  </HelmetProvider>
    </>
  );
}

export default App;
